import { render, staticRenderFns } from "./zhts.vue?vue&type=template&id=1079bb65&scoped=true&"
import script from "./zhts.vue?vue&type=script&lang=js&"
export * from "./zhts.vue?vue&type=script&lang=js&"
import style0 from "./zhts.vue?vue&type=style&index=0&id=1079bb65&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1079bb65",
  null
  
)

export default component.exports